"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.alternative = exports.primary = exports.shades = exports.walletColors = exports.verseColors = void 0;
exports.verseColors = {
    verseBlue: '#0085FF',
    verseLightGray: '#959595',
    verseMidGray: '#8D8D8D',
    verseGrayBrown: '#4B4B4B',
    verseGray: '#424242',
    verseAlmostBlack: '#071921',
    verseBlack: '#050F15',
    verseNavyBlue: '#1A202E',
    verseGrayBlue: '#101624',
    verseDarkBlue: '#001C36',
    verseDarkGrayBlue: '#001C36',
};
exports.walletColors = {
    walletGreen: '#0AC18E',
    walletCyan: '#2FA9EE',
    walletViolet: '#6C43EE',
    walletBlue: '#2933BC',
    walletGold: '#F09E0E',
    walletYellow: '#EDD12E',
    walletRed: '#EE3772',
    walletGray: '#C8CDD8',
};
exports.shades = {
    black: '#000000',
    almostBlack: '#131720',
    extraDark: '#1C212D',
    dark: '#3E4555',
    almostDark: '#2D3345',
    semiDark: '#657089',
    mid: '#8792A8',
    semiLight: '#C8CDD8',
    light: '#E9EBEF',
    extraLight: '#F4F5F8',
    offWhite: '#FAFAFA',
    white: '#FFFFFF',
};
exports.primary = {
    // greens
    primary: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAABYWlDQ1BrQ0dDb2xvclNwYWNlRGlzcGxheVAzAAAokWNgYFJJLCjIYWFgYMjNKykKcndSiIiMUmB/yMAOhLwMYgwKicnFBY4BAT5AJQwwGhV8u8bACKIv64LMOiU1tUm1XsDXYqbw1YuvRJsw1aMArpTU4mQg/QeIU5MLikoYGBhTgGzl8pICELsDyBYpAjoKyJ4DYqdD2BtA7CQI+whYTUiQM5B9A8hWSM5IBJrB+API1klCEk9HYkPtBQFul8zigpzESoUAYwKuJQOUpFaUgGjn/ILKosz0jBIFR2AopSp45iXr6SgYGRiaMzCAwhyi+nMgOCwZxc4gxJrvMzDY7v////9uhJjXfgaGjUCdXDsRYhoWDAyC3AwMJ3YWJBYlgoWYgZgpLY2B4dNyBgbeSAYG4QtAPdHFacZGYHlGHicGBtZ7//9/VmNgYJ/MwPB3wv//vxf9//93MVDzHQaGA3kAFSFl7jXH0fsAAAANSURBVAgdY+A62PcfAASLAlkLqvfVAAAAAElFTkSuQmCC')`,
    primaryLight: '#80E2C5',
    primaryLightest: '#E6F9F4',
    primaryFallback: '#00C58C',
    primaryTransparent: 'rgba(0, 196, 139, 0.1)',
    // blue
    blueGradient: 'linear-gradient(180deg, #3B97FF 0%, #1A87FF 100%)',
    blueGradientLight: 'linear-gradient(180deg, #5EA9FF 0%, #3F9AFF 100%)',
    bluePrimary: '#3B97FF',
    blueLight: '#2FA9EE',
    blueLightest: '#E0F2FC',
    blueTransparent: 'rgba(47, 169, 238, 0.1)',
};
exports.alternative = {
    yellow: '#F19E0F',
    yellowLight: '#F8CE87',
    yellowLightest: '#FDF0DB',
    red: '#E23F2F',
    redLightest: '#FBE2E0',
    violet: '#627CEA',
    violetLight: '#B0BDF4',
    violetLightest: '#E7EBFC',
    orangeGradient: 'linear-gradient(180deg, #f6851b 0%, #dc691b 100%)',
};
exports.colors = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, exports.primary), exports.shades), exports.alternative), exports.walletColors), exports.verseColors);
//# sourceMappingURL=colors.js.map